module.exports = __webpack_public_path__ + "img/y_p3_x4.479e8411.svg";